import { Box, Button, Container, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { errorTitle } from "../styles/errorStyles";
import { primaryButton } from "../styles/commonStyles";

function NotFoundPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  useDocumentTitle("pageNotFound.title");

  return (
    <Container>
      <Box sx={{ textAlign: "center", mt: theme.spacing(5) }}>
        <Typography variant="h1" component="div" gutterBottom sx={errorTitle}>
          404
        </Typography>
        <Typography variant="h4" component="div" gutterBottom color={theme.palette.text.primary}>
          {t("pageNotFound.title")}
        </Typography>
        <Typography variant="body1" gutterBottom color={theme.palette.text.secondary}>
          {t("pageNotFound.description")}
        </Typography>
        <Button
          variant="contained"
          component={Link}
          to="/"
          sx={primaryButton(theme)}
        >
          {t("pageNotFound.goToHome")}
        </Button>
      </Box>
    </Container>
  );
}

export default NotFoundPage;
